import React from 'react';

const Privacy = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="glass-card" style={{ position: 'relative', zIndex: 20 }}>
            <h1 className="commercial-heading text-center mb-4">Privacy Policy</h1>
            <p className="text-center mb-5" style={{ color: '#666', fontSize: '0.9rem' }}>
              Last Updated: January 11, 2026
            </p>

            <div style={{ color: '#000000', lineHeight: '1.8' }}>
              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>1. Introduction</h2>
              <p>
                VowAuthor ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains 
                how we collect, use, disclose, and safeguard your information when you use our wedding vow generation service.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>2. Information We Collect</h2>
              
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>2.1 Personal Information</h3>
              <p>When you purchase our service, we collect:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li>Email address (for code delivery and receipts)</li>
                <li>Payment information (processed securely by Stripe; we do not store card details)</li>
                <li>IP address (for security and fraud prevention)</li>
              </ul>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>2.2 Vow Information</h3>
              <p>When you generate wedding vows, we collect and store:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li>Names and relationship information you provide</li>
                <li>Personal details, memories, and promises you share in the form</li>
                <li>The generated vow text and PDF file</li>
              </ul>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>2.3 Technical Information</h3>
              <p>We automatically collect:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li>Browser type and version</li>
                <li>Device information</li>
                <li>Usage data and analytics</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>3. How We Use Your Information</h2>
              <p>We use the collected information to:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li>Provide and maintain our service</li>
                <li>Process your purchases and deliver redemption codes</li>
                <li>Generate personalized wedding vows based on your input</li>
                <li>Send you receipts and service-related communications</li>
                <li>Respond to your inquiries and support requests</li>
                <li>Detect, prevent, and address technical issues and fraud</li>
                <li>Improve and optimize our service</li>
              </ul>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>4. Data Storage and Retention</h2>
              
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.1 Vow Data</h3>
              <p>
                Generated wedding vows and PDF files are stored for ninety (90) days from creation. After this period, 
                they are automatically and permanently deleted from our servers. We recommend downloading your PDF promptly 
                as a keepsake.
              </p>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.2 Purchase Records</h3>
              <p>
                Purchase information, including email addresses and redemption codes, is retained for accounting and 
                customer service purposes. This data is stored securely in our encrypted database.
              </p>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.3 Data Security</h3>
              <p>
                We implement appropriate technical and organizational security measures to protect your data against 
                unauthorized access, alteration, disclosure, or destruction. We understand the deeply personal nature 
                of wedding vows and treat your data with the utmost care. However, no method of transmission over 
                the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>5. Information Sharing and Disclosure</h2>
              <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>5.1 Service Providers</h3>
              <p>We share information with trusted third-party service providers who assist us in operating our service:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li><strong>Stripe:</strong> Payment processing (subject to Stripe's privacy policy)</li>
                <li><strong>Amazon SES:</strong> Email delivery service</li>
                <li><strong>Amazon Web Services:</strong> Hosting and infrastructure</li>
                <li><strong>OpenAI:</strong> AI-powered vow generation (your data is not used to train models)</li>
              </ul>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>5.2 Legal Requirements</h3>
              <p>We may disclose your information if required to do so by law or in response to valid requests by public authorities.</p>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>5.3 Business Transfers</h3>
              <p>
                In the event of a merger, acquisition, or sale of assets, your information may be transferred to the 
                acquiring entity.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>6. Your Privacy Rights</h2>
              <p>You have the right to:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
                <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
                <li><strong>Deletion:</strong> Request deletion of your personal information (subject to legal retention requirements)</li>
                <li><strong>Opt-out:</strong> Unsubscribe from marketing communications (we only send transactional emails currently)</li>
              </ul>
              <p>To exercise these rights, please contact us using the contact form on our Help page.</p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>7. Cookies and Tracking</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our service and hold certain information. 
                Cookies are files with small amounts of data. You can instruct your browser to refuse all cookies or to 
                indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use 
                some portions of our service.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>8. Children's Privacy</h2>
              <p>
                Our service is intended for adults planning their wedding. We do not knowingly collect personal 
                information from children under 13. If you are a parent or guardian and believe your child has provided us 
                with personal information, please contact us so we can delete such information.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>9. California Privacy Rights</h2>
              <p>
                If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA), 
                including the right to know what personal information we collect, the right to delete your personal information, 
                and the right to opt-out of the sale of your personal information. We do not sell personal information.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>10. International Data Transfers</h2>
              <p>
                Your information may be transferred to and maintained on servers located outside of your state, province, 
                country, or other governmental jurisdiction where data protection laws may differ. By using our service, 
                you consent to such transfers.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>11. Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
                Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy 
                Policy periodically for any changes.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>12. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or our privacy practices, please contact us using the 
                contact form on our Help page.
              </p>

              <div className="mt-5 pt-4" style={{ borderTop: '1px solid rgba(0,0,0,0.1)', textAlign: 'center', color: '#666' }}>
                <p>© {new Date().getFullYear()} VowAuthor. A Lavation Company. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
